/* eslint-disable */

import { Component, ErrorInfo, ReactNode } from 'react';
import { I18nContext } from 'react-i18next';
import { UnknownWorkspaceError } from '../../apiClients/BaseApiClient';
import NotFound from '../../pages/NotFound';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      // Only show 404 for UnknownWorkspaceError
      if (this.state.error instanceof UnknownWorkspaceError) {
        return <NotFound />;
      }

      // For other errors, show generic error page
      return (
        <I18nContext.Consumer>
          {({ i18n }) => (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
              <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl">⚠️</span>
                </div>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">
                  {/* @ts-ignore FIXME */}
                  {i18n.t('errors.somethingWentWrong')}
                </h1>
                <p className="text-gray-600 mb-6">
                  {/* @ts-ignore FIXME */}
                  {i18n.t('errors.unexpectedError')}
                </p>
                <button
                  onClick={() => window.location.reload()}
                  className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-lg hover:opacity-90 transition-opacity"
                >
                  {/* @ts-ignore FIXME */}
                  {i18n.t('common.refresh')}
                </button>
              </div>
            </div>
          )}
        </I18nContext.Consumer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
